<template>
  <div>
    <v-row>
      <v-col cols="3" sm="12" md="12" lg="3" xl="3">
        <v-img
          :src="require('@/assets/background/dashboard/bg-dashboard-blue.png')"
          alt="all-employees"
          class="bg-dashboard-countemployee pa-0"
        >
          <div class="contain-dashboard-allcountemployee">
            <span class="title-dashboard-allcountemployee">จำนวนพนักงานทั้งหมด</span>
            <span class="label-dashboard-allcountemployee">{{emp_all}}</span>
          </div>
        </v-img>
      </v-col>
      <v-col cols="9" sm="12" md="12" lg="9" xl="9" class="pt-0 pb-0">
        <v-row>
          <v-col cols="4" sm="12" md="12" lg="4" xl="4">
            <v-img
              :src="require('@/assets/background/dashboard/bg-dashboard-bluepurple.png')"
              alt="lineofwork"
              class="bg-dashboard-countemployee pa-0"
            >
              <div class="contain-dashboard-countemployee">
                <span class="title-dashboard-countemployee">สายงาน</span>
                <span class="label-dashboard-countemployee">{{emp_lineofwork}}</span>
              </div>
            </v-img>
          </v-col>
          <v-col cols="4" sm="12" md="12" lg="4" xl="4">
            <v-img
              :src="require('@/assets/background/dashboard/bg-dashboard-purple.png')"
              alt="department"
              class="bg-dashboard-countemployee pa-0"
            >
              <div class="contain-dashboard-countemployee">
                <span class="title-dashboard-countemployee">ฝ่ายงาน</span>
                <span class="label-dashboard-countemployee">{{emp_department}}</span>
              </div>
            </v-img>
          </v-col>
          <v-col cols="4" sm="12" md="12" lg="4" xl="4">
            <v-img
              :src="require('@/assets/background/dashboard/bg-dashboard-pinkyellow.png')"
              alt="agency"
              class="bg-dashboard-countemployee pa-0"
            >
              <div class="contain-dashboard-countemployee">
                <span class="title-dashboard-countemployee">ส่วนงาน</span>
                <span class="label-dashboard-countemployee">{{emp_agency}}</span>
              </div>
            </v-img>
          </v-col>
          <v-col cols="4" sm="12" md="12" lg="4" xl="4">
            <v-img
              :src="require('@/assets/background/dashboard/bg-dashboard-bluegreen.png')"
              alt="section"
              class="bg-dashboard-countemployee pa-0"
            >
              <div class="contain-dashboard-countemployee">
                <span class="title-dashboard-countemployee">หน่วยงาน</span>
                <span class="label-dashboard-countemployee">{{emp_section}}</span>
              </div>
            </v-img>
          </v-col>
          <v-col cols="4" sm="12" md="12" lg="4" xl="4">
            <v-img
              :src="require('@/assets/background/dashboard/bg-dashboard-lightergreen.png')"
              alt="workgroup"
              class="bg-dashboard-countemployee pa-0"
            >
              <div class="contain-dashboard-countemployee">
                <span class="title-dashboard-countemployee">กลุ่มงาน</span>
                <span class="label-dashboard-countemployee">{{emp_workgroup}}</span>
              </div>
            </v-img>
          </v-col>
          <v-col cols="4" sm="12" md="12" lg="4" xl="4">
            <v-img
              :src="require('@/assets/background/dashboard/bg-dashboard-orange.png')"
              alt="position"
              class="bg-dashboard-countemployee pa-0"
            >
              <div class="contain-dashboard-countemployee">
                <span class="title-dashboard-countemployee">ตำแหน่ง</span>
                <span class="label-dashboard-countemployee">{{emp_position}}</span>
              </div>
            </v-img>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'overview-dashboard-box',
  props: {
    countemployee: Number,
    typeofmanage: Object,
    count_allemp: Array,
    positions: Array
  },
  data () {
    return {
      typesThis: {},
      positionsThis: [],
      emp_all: 0,
      emp_department: 0,
      emp_agency: 0,
      emp_lineofwork: 0,
      emp_section: 0,
      emp_workgroup: 0,
      emp_position: 0
    }
  },
  created () {
    const self = this
    self.typesThis = self.typeofmanage
    self.positionsThis = self.positions
    self.emp_all = self.countemployee
    self.emp_department = self.typesThis.department.length || 0
    self.emp_agency = self.typesThis.agency.length || 0
    self.emp_lineofwork = self.typesThis.lineofwork.length || 0
    self.emp_section = self.typesThis.section.length || 0
    self.emp_workgroup = self.typesThis.workgroup.length || 0
    self.emp_position = self.positionsThis.length || 0
    // console.log('overview: ', self.typeofmanage)
  }
}
</script>

<style scoped>
.bg-dashboard-countemployee {
  width: 100vw !important;
}

.v-image {
  /* width: 30vw !important; */
  height: 100%;
  object-fit: cover;
  border-radius: 25px;
}

.contain-dashboard-allcountemployee {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 1vw 0.8vw 2vw 3vw;
}

.title-dashboard-allcountemployee {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.25rem;
  color: #fff !important;
}

.label-dashboard-allcountemployee {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 3rem;
  color: #fff !important;
}

.contain-dashboard-countemployee {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 1vw 3vw 2vw 3vw;
}

.title-dashboard-countemployee {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1rem;
  color: #fff !important;
}

.label-dashboard-countemployee {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 1.5rem;
  color: #fff !important;
}
</style>
